import { Fragment, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./Navi.scss";
import axios from "axios";
import jwtDecode from "jwt-decode";
import ConfirmModal from "../components/ConfirmModal";

function Navi() {
  let gnbWrap = useRef();
  let navigate = useNavigate();
  const [showModal2, setShowModal2] = useState(false);
  const [selectValue, setSelectValue] = useState("");
  const selectChange = (event) => {
    setSelectValue(event.target.value);
  };
  const closeModal2 = () => {
    setShowModal2(false);
    setSelectValue("");
  };
  const openShowModal2 = () => {
    const token = window.sessionStorage.getItem("token");
    if (token === null) {
      setShowModal(true);
    } else {
      const decodedToken = jwtDecode(token);
      if (decodedToken.obj.memberType.toUpperCase() === "COMMITTEE") {
        return Swal.fire({
          icon: "error",
          title: "오류",
          text: "위원회계정은 신청이 불가합니다",
          confirmButtonColor: "dodgerBlue",
        });
      } else {
        setShowModal2(true);
      }
    }
  };
  // 모달
  const [showModal, setShowModal] = useState(false);
  const closeModal = () => {
    navigate("/login/userlogin");
    setShowModal(false);
  };
  const goProcess = () => {
    if (selectValue === "") {
      Swal.fire({
        icon: "error",
        title: "오류",
        html: "분야를 선택해주세요",
        confirmButtonColor: "dodgerBlue",
      });
    }
    let tempData = menuData
      .filter((el) => el.name === selectValue)[0]
      .taskGroups.filter((ele) => ele.type === 9);
    if (tempData.length > 0) {
      let tempObj = {};
      tempObj.id = tempData;
      setShowModal2(false);
      navigate("/request/institution", { state: tempObj });
    } else {
      Swal.fire({
        icon: "error",
        title: "오류",
        html: "관리자에 문의해주세요",
        confirmButtonColor: "dodgerBlue",
      });
    }
  };

  useEffect(() => {
    let gnbwrap = document.querySelector(".gnb_wrap");
    let Navi = document.querySelector(".Navi");
    let lnb = document.querySelectorAll(".lnb");
    let lnbA = document.querySelectorAll(".lnb a");
    let logo = document.querySelector(".logo");
    gnbwrap.addEventListener("mouseenter", function () {
      for (let i = 0; i < lnb.length; i++) {
        let newHeight = lnb[i].scrollHeight;
        lnb[i].style.maxHeight = newHeight + "px";
        lnb[i].style.opacity = "1";
        gnbwrap.style.boxShadow = "0 8px 8px rgba(50,50,50,.1)";
      }
    });
    gnbwrap.addEventListener("mouseleave", function () {
      for (let i = 0; i < lnb.length; i++) {
        lnb[i].style.maxHeight = null;
        lnb[i].style.opacity = null;
        gnbwrap.style.boxShadow = null;
      }
    });
    logo.addEventListener("click", function () {
      for (let i = 0; i < lnb.length; i++) {
        lnb[i].style.maxHeight = null;
        lnb[i].style.opacity = null;
        gnbwrap.style.boxShadow = null;
      }
    });
    for (let i = 0; i < lnbA.length; i++) {
      lnbA[i].addEventListener("click", function () {
        for (let i = 0; i < lnb.length; i++) {
          lnb[i].style.maxHeight = null;
          lnb[i].style.opacity = null;
          gnbwrap.style.boxShadow = null;
        }
      });
    }
  });

  const topUserMenu = () => {
    //    console.log(window.sessionStorage.length);
    const token = window.sessionStorage.getItem("token");

    // 토큰이 있는지 확인
    if (token !== null) {
      let jwtdec = jwtDecode(token);

      // 토큰이 있고 멤버 타입이 위원회인 경우
      if (
        token !== null &&
        jwtdec.obj?.memberType.toUpperCase() === "COMMITTEE"
      ) {
        return (
          <>
            <Link to="/committeemy/mycommittee">위원회 My</Link>
            <span>|</span>
            <Link to="/Logout">로그아웃</Link>
          </>
        );
      }
      if (token !== null) {
        return (
          <>
            <Link to="/my">신청기관 My</Link>
            <span>|</span>
            <Link to="/Logout">로그아웃</Link>
          </>
        );
      }
    }

    if (token === null) {
      return (
        <>
          <Link to="/login/userlogin">로그인</Link>
          <span>|</span>
          <Link to="/signup">회원가입</Link>
        </>
      );
    }
  };

  const [menuData, setMenuData] = useState([]);

  const [commMenuData, setCommMenuData] = useState([]);
  const [customerMenuData, setCustomerMenuData] = useState([]);
  // const [commPostData, setCommPostData] = useState([]);
  const getMenuData = async () => {
    try {
      const response = await axios.get("/api/workflow");
      setMenuData(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const goCertPage = (taskGroups) => () => {
    const targetId = taskGroups.filter((e) => e.type === 1);
    navigate(`/certified/${targetId[0].id}`, { state: { id: targetId } });
  };
  const getCommitteeMenu = async () => {
    let commpage = window.sessionStorage.getItem("commpage");
    try {
      if (commpage === null) {
        const response = await axios.get("/api/committee-type");
        window.sessionStorage.setItem(
          "commpage",
          JSON.stringify(response.data.data)
        );
        commpage = JSON.stringify(response.data.data);
      }
      if (window.sessionStorage.getItem("token") !== null) {
        let decodedToken = jwtDecode(window.sessionStorage.getItem("token"));
        let filteredData = JSON.parse(commpage).filter((el) =>
          decodedToken.obj?.commTypes?.includes(el.id)
        );
        setCommMenuData(filteredData);
      }
    } catch (error) {
      console.log(error);
    }
    // console.log(commMenuData);
  };

  const getCustomer = async () => {
    let customer = window.sessionStorage.getItem("customer");
    try {
      if (customer === null) {
        const response = await axios.get("/api/board-type", {
          params: { type: 0 },
        });
        window.sessionStorage.setItem(
          "customer",
          JSON.stringify(response.data.data)
        );
        customer = JSON.stringify(response.data.data);
      }
      setCustomerMenuData(JSON.parse(customer));
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getMenuData();
    getCommitteeMenu();
    // getCommitteeDetailMenu();
    getCustomer();
  }, []);

  const noToken = (address) => () => {
    const token = window.sessionStorage.getItem("token");
    if (token === null) {
      setShowModal(true);
    } else {
      navigate(`/${address}`);
    }
  };
  return (
    <div>
      {showModal2 === true ? (
        <div className="popup_bg_bbs ">
          <div
            className="password_change "
            onClick={(e) => e.stopPropagation()}
          >
            <div className="pophead_bbs">
              <h1>분야선택</h1>
            </div>
            <section className="customcenter_title_row">
              <div className="select_box_contain">
                <div
                  className="select_box"
                  style={{ padding: "20px 20px 0 20px" }}
                >
                  <select defaultValue={""} name="all" onChange={selectChange}>
                    <option value="" disabled>
                      분야
                    </option>
                    {menuData.map((e, idx) => (
                      <Fragment key={idx}>
                        <option value={e.name}>{e.name}</option>
                      </Fragment>
                    ))}
                  </select>
                </div>
              </div>
            </section>
            <div style={{ padding: "20px" }}>
              <div style={{ display: "flex", gap: "3px" }}>
                <button
                  className="btn_none"
                  type="button"
                  style={{ width: "100%" }}
                  onClick={closeModal2}
                >
                  취소
                </button>
                <button
                  className="btn_color"
                  type="button"
                  style={{ width: "100%" }}
                  onClick={goProcess}
                >
                  접수신청
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {showModal ? (
        <ConfirmModal
          closeModal={closeModal}
          modalTitle={"로그인"}
          content={`로그인이 필요한 페이지입니다.`}
        />
      ) : null}
      <nav className="tnb">
        {topUserMenu()}
        {/* <Link to="my">마이페이지</Link>
        <span>|</span>
        <Link to="/login">로그인</Link>
        <span>|</span>
        <Link to="/signup">회원가입</Link> */}
      </nav>
      <nav className="Navi">
        <ul className="gnb_wrap" ref={gnbWrap}>
          <div className="logo">
            <Link to="/">
              <img src="/img/logo.png" alt="logo" />
            </Link>
          </div>
          <li className="gnb">
            <Link to="">인증서비스</Link>
            <ul className="lnb_wrap">
              {menuData
                .filter((el) => el.category === 0)
                .map((e) => (
                  <li
                    key={e.id}
                    className="lnb"
                    onClick={goCertPage(e.taskGroups)}
                  >
                    <a style={{ cursor: "pointer" }}>{e.name}</a>
                  </li>
                ))}
            </ul>
          </li>
          <li className="gnb">
            <Link to="">인정서비스</Link>
            <ul className="lnb_wrap">
              {menuData
                .filter((el) => el.category === 1)
                .map((e) => (
                  <li
                    key={e.id}
                    className="lnb"
                    onClick={goCertPage(e.taskGroups)}
                  >
                    <a style={{ cursor: "pointer" }}>{e.name}</a>
                  </li>
                ))}
            </ul>
          </li>
          <li className="gnb">
            <Link to="">시험서비스</Link>
            <ul className="lnb_wrap">
              {menuData
                .filter((el) => el.category === 2)
                .map((e) => (
                  <li
                    key={e.id}
                    className="lnb"
                    onClick={goCertPage(e.taskGroups)}
                  >
                    <a style={{ cursor: "pointer" }}>{e.name}</a>
                  </li>
                ))}
            </ul>
          </li>
          <li className="gnb">
            <Link to="">민간지원서비스</Link>
            <ul className="lnb_wrap">
              {menuData
                .filter((el) => el.category === 3)
                .map((e) => (
                  <li
                    key={e.id}
                    className="lnb"
                    onClick={goCertPage(e.taskGroups)}
                  >
                    <a style={{ cursor: "pointer" }}>{e.name}</a>
                  </li>
                ))}
            </ul>
          </li>
          <li className="gnb">
            <Link to="">심사현황</Link>
            <ul className="lnb_wrap">
              <li className="lnb">
                <Link to="/reviewcompletionstatus">현황</Link>
              </li>
            </ul>
          </li>
          {window.sessionStorage.getItem("committee") && (
            <li className="gnb">
              {window.sessionStorage.getItem("committee") ? (
                <Link to="">위원회</Link>
              ) : (
                <Link to="/login/committee">위원회</Link>
              )}
              <ul className="lnb_wrap">
                {window.sessionStorage.getItem("committee")
                  ? commMenuData.map((value) => {
                      return (
                        <li
                          className="lnb"
                          key={value.id}
                          onClick={() => {
                            navigate(`/committeeprocess/${value.id}`);
                          }}
                        >
                          <Link to="/committeeprocess">{value.name}</Link>
                        </li>
                      );
                    })
                  : null}
              </ul>
            </li>
          )}

          <li className="gnb">
            <Link to="">알림</Link>
            <ul className="lnb_wrap">
              <li className="lnb">
                <Link to="/notice">공지사항</Link>
              </li>
              <li className="lnb">
                <Link to="/announcement">공고</Link>
              </li>
              <li className="lnb">
                <Link to="/disclosure">고시</Link>
              </li>
              <li className="lnb">
                <Link to="/standard">기준</Link>
              </li>
            </ul>
          </li>
          <li className="gnb">
            <Link to="">고객마당</Link>
            <ul className="lnb_wrap">
              <li className="lnb" onClick={noToken("dataroom")}>
                <a style={{ cursor: "pointer" }}>자료실</a>
              </li>
              <li className="lnb">
                <a style={{ cursor: "pointer" }} onClick={openShowModal2}>
                  이의불만분쟁
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default Navi;
